"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Selector_1 = __importDefault(require("./Selector"));
exports.default = Selector_1.default;
